export default function average(...args: number[]) {
    return args.reduce((output, value) => output + value, 0) / args.length;
}
